import React from 'react';
import { Button } from '@strava/ui/Button';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import clsx from 'clsx';

import { Modal } from '@strava/ui/Modal';
import NavigationInformationNormalXsmall from '@strava/icons/NavigationInformationNormalXsmall';

import styles from './styles.scss';

const InfoModal = ({ children, className = '' }) => {
  return (
    <>
      <Modal
        shouldShowCloseButtonIcon={true}
        triggerProps={{
          render: (renderProps) => (
            <Button
              {...renderProps}
              className={clsx(styles.infoButton, className)}
              variant="icon"
              type="button"
              aria-label={I18n.t('strava.info.modal.open_modal')}
            >
              <NavigationInformationNormalXsmall
                color="grey"
                aria-hidden={true}
              />
            </Button>
          )
        }}
      >
        <Modal.Content>
          <Modal.Body>{children}</Modal.Body>
        </Modal.Content>
      </Modal>
    </>
  );
};

InfoModal.propTypes = {
  children: PropTypes.element.isRequired,
  className: PropTypes.string
};

export default InfoModal;
